import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { useQuote } from "@/context/QuoteContext";
import { useBodyScrollLock } from "@/hooks/useBodyScrollLock";
import { defaultConfiguration, validateConfiguration, configuredItems } from "./doorConfiguration";

export function useDoorConfiguration(open, model, onClose) {
  const { addToCart } = useQuote();
  const [form, setForm] = useState(() => defaultConfiguration(model));
  const [error, setError] = useState("");
  useBodyScrollLock(open);
  useEffect(() => {
    if (open) { setForm(defaultConfiguration(model)); setError(""); }
  }, [open, model]);
  useEffect(() => {
    if (!open) return;
    const onKey = (event) => { if (event.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  const set = useCallback((field, value) => {
    setForm((previous) => ({ ...previous, [field]: typeof value === "function" ? value(previous[field]) : value }));
    setError("");
  }, []);
  const add = (photo) => {
    const message = validateConfiguration(model, form);
    if (message) { setError(message); toast.error(message); return false; }
    configuredItems(model, form, photo).forEach(addToCart);
    onClose();
    return true;
  };
  return { form, set, error, add };
}